module.exports = __webpack_public_path__ + "Typedepot---CentraleSansLight.6116b3214ae8efdf5f00.woff";


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/assets/fonts/Typedepot---CentraleSansLight.woff
// module id = ../../../../../src/assets/fonts/Typedepot---CentraleSansLight.woff
// module chunks = styles